/* eslint-disable import/no-named-as-default-member */
import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import propTypes, { shape } from 'prop-types';
import colorSchemes, {
  darkGrayRGBA,
  featherGray,
} from '../../../../cra/src/styling/theme';
import breakpointsMinWidth from '../../../../cra/src/styling/breakpointsMinWidth';
import { cleanPathname, featurePages } from '../../../constants/navbar';

const ToolbarWrapper = styled.nav`
  grid-column: 1/-1;
  display: grid;
  align-items: center;
  grid-template-columns: repeat(12, 1fr);
  grid-gap: 1.5rem;
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  height: 58px;
  z-index: 49;
  background: ${colorSchemes.white};
  box-shadow: 0 1px 0 ${() => darkGrayRGBA(0.2)};
  z-index: ${(props) => props.showSideDrawer && '5'};
  transition: background 0.3s ease-out;

  @media (max-width: 1023px) {
    grid-template-columns: repeat(8, 1fr);
  }

  @media screen and (max-width: 767px) {
    grid-template-columns: repeat(4, 1fr);
    padding: 0 16px;
  }

  @media ${breakpointsMinWidth.tabletMd} {
    height: 50px;
  }

  @media ${breakpointsMinWidth.desktopSm} {
    height: 56px;
  }

  @media ${breakpointsMinWidth.desktopMd} {
    height: 72px;
  }

  ${(props) => {
    const { pathname, isTop, menuBar, appType } = props;
    if (
      appType !== 'CRA' &&
      featurePages.includes(cleanPathname(pathname)) &&
      pathname !== '/'
    ) {
      return css`
        background: linear-gradient(
          90deg,
          #8510df 10%,
          #2364eb 60%,
          #397cef 86%,
          #4487f1 97%
        );
      `;
    }
    if (
      pathname === '/about-us' ||
      pathname === '/about-us/' ||
      pathname === '/'
    ) {
      if (isTop) {
        return css`
          background: none;
          box-shadow: none;
        `;
      }

      return css`
        background: white;
        box-shadow: 0 12px 24px -6px rgba(41, 49, 89, 0.3);
      `;
    }

    if (pathname.includes('/documents/')) {
      return css`
        height: 44px;
        @media ${breakpointsMinWidth.tabletMd} {
          height: 44px;
        }

        @media ${breakpointsMinWidth.desktopSm} {
          height: 44px;
        }

        @media ${breakpointsMinWidth.desktopMd} {
          height: 48px;
        }
        display: ${!menuBar ? 'none' : 'grid'};
        max-height: ${!menuBar ? '0' : '48px'};
        transition: max-height 0.3s ease-in-out;
      `;
    }

    if (
      pathname.startsWith('/drive') ||
      pathname.startsWith('/account') ||
      pathname.startsWith('/support') ||
      pathname.startsWith('/billings') ||
      pathname.startsWith('/services') ||
      pathname.startsWith('/learn') ||
      pathname.startsWith('/documents/')
    ) {
      return css`
        background-color: ${featherGray};
        height: 58px;
        box-shadow: none;
        @media ${breakpointsMinWidth.tabletMd} {
          height: 58px;
        }

        @media ${breakpointsMinWidth.desktopSm} {
          height: 58px;
        }

        @media ${breakpointsMinWidth.desktopMd} {
          height: 58px;
        }
        @media screen and (max-width: 425px) {
          padding: 0 16px;
        }
      `;
    }

    return null;
  }}
`;

/**
 * Todo: change to presentational if there is no state
 */
class Toolbar extends Component {
  state = {};

  render() {
    const {
      children,
      pathname,
      isTop,
      dataTestId,
      showSideDrawer,
      navBarRef,
      userPreferences,
      formatType,
      appType,
    } = this.props;
    const { layout } = userPreferences || {};
    const { menuBar } = layout || { menuBar: true };

    return (
      <ToolbarWrapper
        pathname={pathname}
        isTop={isTop}
        data-testid={dataTestId}
        showSideDrawer={showSideDrawer}
        menuBar={menuBar}
        formatType={formatType}
        ref={navBarRef}
        appType={appType}
      >
        {children}
      </ToolbarWrapper>
    );
  }
}

Toolbar.propTypes = {
  children: propTypes.node.isRequired,
  pathname: propTypes.string.isRequired,
  isTop: propTypes.bool.isRequired,
  userPreferences: shape({
    layout: shape({
      menuBar: propTypes.bool,
    }),
  }),
};
Toolbar.defaultProps = {
  userPreferences: {
    layout: { menuBar: true },
  },
};

export default Toolbar;
